// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"ed86fb2d","416":"30cd7ccc","436":"78f4b568","574":"20fa78a8","883":"699aab63"}[chunkId] + ".chunk.js";
};